import React from 'react';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';

// Хелпер для получения класса темы (с фоллбэком)
const useThemeClass = () => {
  const theme = useStore(state => state.ref.menu.activeTheme) || 'cardcolor';
  return `mafia-generic-card theme-${theme}`;
};

// 1. ЭКРАН ЗАГРУЗКИ
export const LoadingScreen = () => {
  const { t } = useTranslation();
  // Для загрузки форсируем нейтральную или базовую тему, если активная еще не пришла
  const theme = useStore(state => state.ref.menu.activeTheme) || 'cardcolor';
  const cardClass = `mafia-generic-card theme-${theme}`;

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral">
          {/* Вместо иконки используем CSS-спиннер */}
          <div className="mafia-loader-spinner"></div>
          <div className="mpc-title">{t('mafia.system.loading_title', 'ЗАГРУЗКА...')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{t('mafia.system.loading_desc', 'Подключение к игре...')}</p>
        </div>
      </div>
    </div>
  );
};

// 2. ЭКРАН "ИГРА НЕ НАЙДЕНА" (Или ошибка)
export const NotFoundScreen = ({ isError }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  const title = isError
    ? t('mafia.system.error_title', 'ОШИБКА')
    : t('mafia.system.not_found_title', 'НЕ НАЙДЕНО');

  const desc = isError
    ? t('mafia.system.error_desc', 'Произошла ошибка загрузки.')
    : t('mafia.system.not_found_desc', 'Игра не найдена или устарела.');

  const icon = isError ? '⚠️' : '🔍';

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral">
          <div className="mpc-icon">{icon}</div>
          <div className="mpc-title">{title}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{desc}</p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close')}
        </button>
      </div>
    </div>
  );
};

export const GameOverScreen = () => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral">
          <div className="mpc-icon">🏁</div>
          <div className="mpc-title">{t('mafia.game_over')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{t('mafia.game_over_desc')}</p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close')}
        </button>
      </div>
    </div>
  );
};

export const AccessDeniedScreen = ({ reason }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  let icon = '🔒';
  let title = t('mafia.access_denied', 'Доступ к чату ограничен.');
  let errorText = t('mafia.spectator_error_generic', 'Доступ к чату ограничен.');


  if (reason === 'no_spectators') {
    icon = '👀';
    title = t('mafia.spectator_title', 'Вы ЗРИТЕЛЬ');
    errorText = t('mafia.spectator_no_spectators', 'Вы не участвуете. Обязательно заходите на следующую игру!')
  };
  if (reason === 'not_member') errorText = t('mafia.spectator_not_member', 'Вы должны состоять в группе.');
  if (reason === 'restricted') errorText = t('mafia.spectator_restricted', 'Вы не можете писать в чат, так как у вас мут в группе.');

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral">
          <div className="mpc-icon">{icon}</div>
          <div className="mpc-title">{title}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{errorText}</p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close')}
        </button>
      </div>
    </div>
  );
};

export const SpectatorScreen = () => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral">
          <div className="mpc-icon">👀</div>
          <div className="mpc-title">{t('mafia.spectator_title', 'ВЫ ЗРИТЕЛЬ')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">
            {t('mafia.spectator_desc', 'Вы не участвуете. Обязательно заходите на следующую игру!')}
          </p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close')}
        </button>
      </div>
    </div>
  );
};